<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="radioOne.data" [valueSelected]="radioOne.valueSelected"
                    (selectAnswer)="onRadioOneSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="radioTwo.data" [valueSelected]="radioTwo.valueSelected"
                    (selectAnswer)="onRadioTwoSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <radio-question [data]="radioThree.data" [valueSelected]="radioThree.valueSelected"
                    (selectAnswer)="onRadioThreeSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <radio-question [data]="radioFour.data" [valueSelected]="radioFour.valueSelected"
                    (selectAnswer)="onRadioFourSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">5</i>
    <radio-question [data]="radioFive.data" [valueSelected]="radioFive.valueSelected"
                    (selectAnswer)="onRadioFiveSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">6</i>
    <radio-question [data]="radioSix.data" [valueSelected]="radioSix.valueSelected"
                    (selectAnswer)="onRadioSixSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">7</i>
    <radio-question [data]="radioSeven.data" [valueSelected]="radioSeven.valueSelected"
                    (selectAnswer)="onRadioSevenSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">8</i>
    <select-question [data]="selectQuestion.data" [valueSelected]="selectQuestion.valueSelected"
                     (selectAnswer)="onSelectQuestionSelected($event)"></select-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
